import { LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ZipProgress } from '../../../../../utils/api/downloadGameMediaZip/downloadGameMediaZip';

interface MediaExportProgressModalProps {
  isLoading: boolean;
  progress: ZipProgress | null;
}

// GMT-797 (Porcja 2): blokujący modal eksportu mediów.
// - jest progres per-plik (Chrome, po wyborze lokalizacji) → pasek determinowany + licznik,
// - brak progresu (Safari/backend LUB Chrome czekający na okno zapisu) → pasek
//   nieokreślony (animowany) + "Przygotowywanie…". Blokuje UI i sygnalizuje, że coś się dzieje.
const barSx = {
  height: 8,
  borderRadius: 4,
  backgroundColor: '#F0F0F0',
  '& .MuiLinearProgress-bar': { backgroundColor: '#B02B17' },
};

const MediaExportProgressModal = ({ isLoading, progress }: MediaExportProgressModalProps) => {
  const { t } = useTranslation();

  if (!isLoading) {
    return null;
  }

  const hasProgress = !!progress && progress.total > 0 && progress.done > 0;
  const percent = hasProgress ? Math.round((progress.done / progress.total) * 100) : 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-96 max-w-full rounded-lg bg-white p-6 shadow-lg">
        <p className="mb-1 font-semibold">{t('mediaExport.packing')}</p>
        <p className="mb-3 text-sm text-grey700">
          {hasProgress
            ? t('mediaExport.progress', {
                done: progress.done,
                total: progress.total,
                percent,
              })
            : t('mediaExport.preparing')}
        </p>

        {hasProgress ? (
          <LinearProgress variant="determinate" value={percent} sx={barSx} />
        ) : (
          <LinearProgress sx={barSx} />
        )}

        {!!progress && progress.skipped > 0 && (
          <p className="mt-2 text-xs text-grey700">{t('mediaExport.skipped', { count: progress.skipped })}</p>
        )}
      </div>
    </div>
  );
};

export default MediaExportProgressModal;
